import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const SaleTransferPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">売上金・振込について</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="w-full justify-center text-black text-base font-normal leading-7">
                売上金とは、商品を販売して得られる販売利益のことを指します。<br/>
                売上金は、商品が鑑定を通過した時点でアカウントに付与されます。<br/>
                売上が確定してから180日以内に振込申請を行ってください。<br/>
                ※売上金を利用して商品を購入することはできません。
              </div>
              <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">売上金額の計算方法</div>
                <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    売上金額は、以下の計算式に基づいて算出されます<br/>
                    ・販売価格（商品代金） −販売手数料
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="self-stretch px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">振込申請について</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-base font-normal leading-7">
                売上金を受け取るには、振込申請が必要です。<br/>
                申請後、売上金はご指定の口座へ一括でお振り込みいたします。
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="justify-center text-black text-base font-normal leading-7">振込申請の手順については、以下のページをご確認ください。</div>
                <Link to={`/terms/request_withdrawal${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">売上金の振込申請手順</Link>
              </div>
              <div className="justify-center text-black text-base font-normal leading-7">
                ※振込対象となるのは、日本国内の金融機関の口座のみです。<br/>
                ※売上金の一部のみを選んでの振込申請や、海外の銀行口座への送金には対応しておりません。
              </div>
            </div>
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">振込手数料</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ¥550<br/>
                  振込手数料とは、振込申請後の口座振込に伴う手数料です。<br/>
                  指定口座には総売上金額から手数料を差し引いた金額が振り込まれます。<br/>
                  ※取引キャンセルにより返金した売上金には振込手数料はかかりませんが、取引完了分の売上金とあわせて振込申請をおこなった場合は、合計金額に基づき振込手数料が発生いたします。
                </div>
              </div>
            </div>
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">振込スケジュール</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  振込申請後、申請日から5営業日以内にご指定の口座へ着金予定です。<br/>
                  ※ここでの「営業日」とは、金融機関の営業日を指します。<br/>
                  なお、口座情報の誤りなどにより振込が失敗した場合は、取引メッセージにてご連絡いたします。<br/>
                  その際は、内容をご確認のうえ、再度振込申請をお願いいたします。
                </div>
              </div>
            </div>
          </div>

          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="self-stretch px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="w-full justify-center text-black text-2xl font-bold leading-9">振込申請期限について</div>
            </div>
            <div className="w-full justify-center text-black text-base font-normal leading-7">
              売上金には振込申請の期限が設けられており、期限を過ぎた売上金は一律で失効となります。<br/>
              振込申請期限にご注意のうえ、余裕をもってお手続きください。
            </div>
            <div className="self-stretch flex flex-col justify-center items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">振込申請期限</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  売上金は、反映日を1日目として180日目までとなります。<br/>
                  180日を超過した場合は売上金は失効となりますので、あらかじめご注意ください。
                </div>
              </div>
            </div>
            <div className="self-stretch flex flex-col justify-center items-start gap-2.5">
              <div className="w-full justify-center text-black text-xl font-bold leading-[30px]">振込申請が期限内に行われなかった場合</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  振込申請が期限内に行われなかった場合、売上金は失効となり、いかなる場合もお戻しはできませんので、あらかじめご了承ください。<br/>
                  申請期限に十分ご注意のうえ、余裕を持ってお手続きをお願いいたします。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default SaleTransferPage;